/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 0 = more than 50%, 1 = less than 50%, 2 = totally empty.
 * @export
 */
export const BuildingOccupancy = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;
export type BuildingOccupancy = typeof BuildingOccupancy[keyof typeof BuildingOccupancy];


export function instanceOfBuildingOccupancy(value: any): boolean {
    for (const key in BuildingOccupancy) {
        if (Object.prototype.hasOwnProperty.call(BuildingOccupancy, key)) {
            if (BuildingOccupancy[key as keyof typeof BuildingOccupancy] === value) {
                return true;
            }
        }
    }
    return false;
}

export function BuildingOccupancyFromJSON(json: any): BuildingOccupancy {
    return BuildingOccupancyFromJSONTyped(json, false);
}

export function BuildingOccupancyFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuildingOccupancy {
    return json as BuildingOccupancy;
}

export function BuildingOccupancyToJSON(value?: BuildingOccupancy | null): any {
    return value as any;
}

export function BuildingOccupancyToJSONTyped(value: any, ignoreDiscriminator: boolean): BuildingOccupancy {
    return value as BuildingOccupancy;
}

